/** @return {import("picoxiaDicom")} */
const getPicoxiaDicom = () => window.nodeModules?.picoxiaDicom;

export default getPicoxiaDicom;
